<template>
  <loadingView v-if="loading" />
  <NavbarView />
  <div class="mt-14">
    <router-view />
  </div>
</template>

<script>
import NavbarView from "./components/Navbar.vue";
import loadingView from "@/components/Loading.vue";
import { computed } from "vue";
import { useStore } from "vuex";
export default {
  name: "app",
  components: {
    NavbarView,
    loadingView,
  },
  setup() {
    const store = useStore();
    const loading = computed(() => {
      return store.state.loading;
    });
    return {
      loading,
    };
  },
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
